var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "b-card",
        { staticClass: "card-revenue-budget", attrs: { "no-body": "" } },
        [
          _c(
            "b-row",
            { staticClass: "mx-0" },
            [
              _c(
                "b-col",
                { staticClass: "revenue-report-wrapper", attrs: { md: "12" } },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-sm-flex justify-content-between align-items-center mb-3",
                    },
                    [
                      _c("h4", { staticClass: "card-title mb-50 mb-sm-0" }, [
                        _vm._v(" Sales Trend "),
                      ]),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center mr-2" },
                          [
                            _c("span", {
                              staticClass:
                                "bullet bullet-primary svg-font-small-3 mr-50 cursor-pointer",
                            }),
                            _c("span", [_vm._v("Earning")]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center ml-75" },
                          [
                            _c("span", {
                              staticClass:
                                "bullet bullet-warning svg-font-small-3 mr-50 cursor-pointer",
                            }),
                            _c("span", [_vm._v("Expense")]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c("vue-apex-charts", {
                    attrs: {
                      id: "revenue-report-chart",
                      type: "bar",
                      height: "230",
                      options: _vm.revenueReport.chartOptions,
                      series: _vm.data.revenueReport.series,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }